import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6e793f2f"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "formula-icon-container"
};
const _hoisted_2 = {
  class: "formula-icon-container"
};
const _hoisted_3 = {
  class: "formula-icon-container"
};
const _hoisted_4 = {
  class: "formula-icon-container"
};
const _hoisted_5 = {
  class: "targeting-type-container"
};
const _hoisted_6 = {
  class: "targeting"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_th = _resolveComponent("b-th");
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_EqualsIcon = _resolveComponent("EqualsIcon");
  const _component_b_tr = _resolveComponent("b-tr");
  const _component_b_thead = _resolveComponent("b-thead");
  const _component_b_td = _resolveComponent("b-td");
  const _component_currency_value = _resolveComponent("currency-value");
  const _component_percentage_value = _resolveComponent("percentage-value");
  const _component_b_tbody = _resolveComponent("b-tbody");
  const _component_b_table_simple = _resolveComponent("b-table-simple");
  const _component_flex_row = _resolveComponent("flex-row");
  return _openBlock(), _createBlock(_component_flex_row, {
    class: "bid-simulator"
  }, {
    default: _withCtx(() => [_createVNode(_component_b_table_simple, null, {
      default: _withCtx(() => [_createVNode(_component_b_thead, {
        class: "table-header"
      }, {
        default: _withCtx(() => [_createVNode(_component_b_tr, {
          class: "header",
          style: {
            "margin-top": "0"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_b_th, {
            class: "title targeting-type"
          }, {
            default: _withCtx(() => [_createTextVNode(" TARGETING TYPE BREAKDOWN ")]),
            _: 1
          }), _createVNode(_component_b_th, {
            class: "title percent-reinvestment"
          }, {
            default: _withCtx(() => [_createTextVNode(" % OF REINVESTMENT "), _createElementVNode("div", _hoisted_1, [_createVNode(_component_app_icon, {
              icon: "cross",
              size: 12,
              color: "#adadad"
            })])]),
            _: 1
          }), _createVNode(_component_b_th, {
            class: "title avg-margin-per-click"
          }, {
            default: _withCtx(() => [_createTextVNode(" AVG. MARGIN PER CLICK "), _createElementVNode("div", _hoisted_2, [_createVNode(_component_EqualsIcon, {
              height: 12,
              width: 12,
              color: "#adadad"
            })])]),
            _: 1
          }), _createVNode(_component_b_th, {
            class: "title product-margin"
          }, {
            default: _withCtx(() => [_createTextVNode(" PRODUCT MARGIN "), _createElementVNode("div", _hoisted_3, [_createVNode(_component_app_icon, {
              icon: "cross",
              size: 12,
              color: "#adadad"
            })])]),
            _: 1
          }), _createVNode(_component_b_th, {
            class: "title ads-cvr"
          }, {
            default: _withCtx(() => [_createTextVNode(" ADS CVR ")]),
            _: 1
          }), _createVNode(_component_b_th, {
            class: "title product-boost"
          }, {
            default: _withCtx(() => [_createTextVNode(" PRODUCT BOOST ")]),
            _: 1
          }), _createVNode(_component_b_th, {
            class: "title computed-max-bid"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createVNode(_component_EqualsIcon, {
              height: 12,
              width: 12,
              color: "#adadad"
            })]), _createTextVNode(" COMPUTED MAX BID ")]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_b_tbody, {
        class: "table-body"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.targeting_types, key => {
          return _openBlock(), _createBlock(_component_b_tr, {
            class: "targeting-field"
          }, {
            default: _withCtx(() => [_createVNode(_component_b_td, {
              class: "target-info targeting-type"
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", {
                class: "title-icon",
                style: _normalizeStyle({
                  color: $data.targetingTypeTitleIconMap[key]?.color
                })
              }, [_createVNode(_component_app_icon, {
                icon: $data.targetingTypeTitleIconMap[key]?.icon,
                size: "16"
              }, null, 8, ["icon"]), _createTextVNode(" " + _toDisplayString($data.targetingTypeTitleIconMap[key]?.title), 1)], 4), _createElementVNode("div", _hoisted_6, _toDisplayString($options.getTargeting(key)), 1)])]),
              _: 2
            }, 1024), _createVNode(_component_b_td, {
              class: "target-info"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString($props.targeting[$data.key_mapping[key]]) + "% ", 1)]),
              _: 2
            }, 1024), _createVNode(_component_b_td, {
              class: "target-info avg-margin-per-click"
            }, {
              default: _withCtx(() => [_createVNode(_component_currency_value, {
                value: $options.avgMargin(key),
                currency: $props.currency,
                precision: $data.precision,
                allowPrecisionModification: false
              }, null, 8, ["value", "currency", "precision"])]),
              _: 2
            }, 1024), _createVNode(_component_b_td, {
              class: "target-info product-margin"
            }, {
              default: _withCtx(() => [_createVNode(_component_currency_value, {
                value: $options.getProductMargin(key),
                currency: $props.currency,
                precision: $data.precision,
                allowPrecisionModification: false
              }, null, 8, ["value", "currency", "precision"])]),
              _: 2
            }, 1024), _createVNode(_component_b_td, {
              class: "target-info ads-cvr"
            }, {
              default: _withCtx(() => [_createVNode(_component_percentage_value, {
                value: $options.getCvr(key)
              }, null, 8, ["value"])]),
              _: 2
            }, 1024), _createVNode(_component_b_td, {
              class: "target-info product-boost"
            }, {
              default: _withCtx(() => [_createTextVNode(" 1x ")]),
              _: 1
            }), _createVNode(_component_b_td, {
              class: "target-info computed-max-bid"
            }, {
              default: _withCtx(() => [_createVNode(_component_currency_value, {
                value: $options.computedMaxBid(key),
                currency: $props.currency,
                precision: $data.precision,
                allowPrecisionModification: false
              }, null, 8, ["value", "currency", "precision"])]),
              _: 2
            }, 1024)]),
            _: 2
          }, 1024);
        }), 256))]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  });
}